import React, {Component} from 'react';
import { Modal, Spin } from 'antd';

// 简易 Markdown → HTML 转换，覆盖操作手册中使用的语法
function markdownToHtml(md) {
  if (!md) return '';

  const escapeHtml = (text) =>
    text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  let lines = md.split('\n');
  let html = '';
  let inTable = false;
  let inCodeBlock = false;
  let tableHtml = '';
  let inTbody = false;

  function flushTable() {
    if (!inTable) return;
    let result = tableHtml;
    if (inTbody) result += '</tbody>';
    result += '</table>';
    tableHtml = '';
    inTable = false;
    inTbody = false;
    return result;
  }

  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];

    // Code block
    if (line.trim().startsWith('```')) {
      if (inCodeBlock) {
        html += '</code></pre>';
        inCodeBlock = false;
        continue;
      } else {
        html += flushTable() || '';
        html += '<pre><code>';
        inCodeBlock = true;
        continue;
      }
    }
    if (inCodeBlock) {
      html += escapeHtml(line) + '\n';
      continue;
    }

    // Horizontal rule
    if (line.trim() === '---') {
      html += flushTable() || '';
      html += '<hr/>';
      continue;
    }

    // Table
    if (line.trim().startsWith('|') && line.trim().endsWith('|')) {
      let cells = line.split('|').slice(1, -1).map(c => c.trim());
      let isHeaderSep = cells.every(c => /^[-:]+$/.test(c));
      if (isHeaderSep) continue;

      if (!inTable) {
        html += '<table>';
        inTable = true;
        inTbody = false;
      }

      // First data row after table start — headers are the previous non-separator row
      // We need to peek: if next row is separator, this is header
      let nextLine = (i + 1 < lines.length) ? lines[i + 1].trim() : '';
      let nextIsSep = nextLine.startsWith('|') && nextLine.endsWith('|') &&
        nextLine.split('|').slice(1, -1).map(c => c.trim()).every(c => /^[-:]+$/.test(c));

      if (nextIsSep) {
        tableHtml += '<thead><tr>';
        cells.forEach(c => { tableHtml += '<th>' + inlineMarkdown(c) + '</th>'; });
        tableHtml += '</tr></thead>';
        continue;
      }

      if (!inTbody) {
        tableHtml += '<tbody>';
        inTbody = true;
      }
      tableHtml += '<tr>';
      cells.forEach(c => { tableHtml += '<td>' + inlineMarkdown(c) + '</td>'; });
      tableHtml += '</tr>';
      continue;
    } else {
      html += flushTable() || '';
    }

    // Empty line
    if (line.trim() === '') {
      html += '';
      continue;
    }

    // Headers
    if (line.startsWith('#### ')) {
      html += '<h4>' + inlineMarkdown(line.slice(5)) + '</h4>';
      continue;
    }
    if (line.startsWith('### ')) {
      html += '<h3>' + inlineMarkdown(line.slice(4)) + '</h3>';
      continue;
    }
    if (line.startsWith('## ')) {
      html += '<h2>' + inlineMarkdown(line.slice(3)) + '</h2>';
      continue;
    }
    if (line.startsWith('# ')) {
      html += '<h1>' + inlineMarkdown(line.slice(2)) + '</h1>';
      continue;
    }

    // Blockquote
    if (line.startsWith('> ')) {
      html += '<blockquote>' + inlineMarkdown(line.slice(2)) + '</blockquote>';
      continue;
    }

    // Unordered list
    if (line.match(/^[-*] /)) {
      html += '<li>' + inlineMarkdown(line.slice(2)) + '</li>';
      continue;
    }

    // Default paragraph
    html += '<p>' + inlineMarkdown(line) + '</p>';
  }

  html += flushTable() || '';
  if (inCodeBlock) html += '</code></pre>';

  return html;
}

function inlineMarkdown(text) {
  // Bold
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  // Inline code
  text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
  return text;
}

class OperationManualModal extends Component {
  state = {
    htmlContent: '',
    loading: true,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.fetchManual();
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.fetchManual();
    }
  }

  fetchManual = () => {
    this.setState({ loading: true });
    fetch('/操作手册.md')
      .then(res => res.text())
      .then(md => {
        this.setState({ htmlContent: markdownToHtml(md), loading: false });
      })
      .catch(() => {
        this.setState({ htmlContent: '<p>操作手册加载失败</p>', loading: false });
      });
  };

  render() {
    const { visible, onClose } = this.props;
    const { htmlContent, loading } = this.state;

    return (
      <Modal
        title="Portfolio Monitoring Rule 操作手册"
        visible={visible}
        onCancel={onClose}
        footer={null}
        width={1000}
        destroyOnClose
        bodyStyle={{ maxHeight: '70vh', overflow: 'auto' }}
      >
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}><Spin size="large" /></div>
        ) : (
          <div
            className="operation-manual-content"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}
      </Modal>
    );
  }
}

export default OperationManualModal;
